"use strict";
var fails = require("../internals/fails");
module.exports = function(METHOD_NAME) {
  return fails(function() {
    var test = ""[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};
